import { CloseIcon, OpenExternalIcon } from "@/components/appIcons";
import { ReleaseImageLightboxAsset } from "@/components/release-image-lightbox-asset";
import { ReleaseImageLightboxNavigation } from "@/components/release-image-lightbox-navigation";

export function ReleaseImageLightboxView({
  analyticsSurface,
  assetLoading,
  assetType,
  assetUrl,
  displaySrcSet,
  displayUrl,
  imageLabel,
  onClose,
  onLoadEnd,
  onNext,
  onPrevious,
  sizes,
  title,
  totalImages,
}: {
  analyticsSurface?: string;
  assetLoading: boolean;
  assetType: ReleaseImage["assetType"];
  assetUrl: string;
  displaySrcSet: string | undefined;
  displayUrl: string;
  imageLabel: string;
  onClose: () => void;
  onLoadEnd: () => void;
  onNext: () => void;
  onPrevious: () => void;
  sizes: string;
  title: string;
  totalImages: number;
}) {
  const withNavigation = totalImages > 1;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={imageLabel}
      aria-busy={assetLoading}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-20 flex size-10 items-center after:absolute after:-inset-0.5 after:content-[''] justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
        aria-label="Close"
      >
        <CloseIcon />
      </button>
      <a
        href={assetUrl}
        target="_blank"
        rel="noreferrer"
        onClick={(event) => {
          event.stopPropagation();
          if (!analyticsSurface) return;
        }}
        className="absolute top-4 right-16 z-20 flex size-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
        aria-label="Open original"
      >
        <OpenExternalIcon />
      </a>
      <ReleaseImageLightboxNavigation
        imageLabel={imageLabel}
        onNext={onNext}
        onPrevious={onPrevious}
        visible={withNavigation}
      />
      <ReleaseImageLightboxAsset
        assetLoading={assetLoading}
        assetType={assetType}
        assetUrl={assetUrl}
        displaySrcSet={displaySrcSet}
        displayUrl={displayUrl}
        imageLabel={imageLabel}
        onLoadEnd={onLoadEnd}
        onNext={onNext}
        onPrevious={onPrevious}
        sizes={sizes}
        title={title}
        withNavigation={withNavigation}
      />
    </div>
  );
}
import type { ReleaseImage } from "@garimpa/api/music/getReleaseImages";
